import styles from './MaintenanceSwitcher.module.css';

export const Maintenance = {PM: "pm", CM: "cm", PM_CM: null};

export const MaintenanceSwitcher = ({value, onChange}) => {
	const modes = [
		{label: "PM", value: Maintenance.PM},
		{label: "CM", value: Maintenance.CM},
		{label: "PM + CM", value: Maintenance.PM_CM},
	];

	return (
		<div className={styles.modeSwitchButton}>
			{modes.map(m => (
				<button
					key={m.value}
					className={value === m.value ? styles.modeBtnActive : styles.modeBtn}
					onClick={() => onChange(m.value)}>
					{m.label}
				</button>
			))}
		</div>
	);
};
